import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export const SITE_URL = 'https://fliesen-jarek.de';
export const SITE_NAME = 'Fliesen Jarek';

const DEFAULT_TITLE = 'Fliesenleger Cuxhaven: Badsanierung | Fliesen Jarek';
const DEFAULT_DESCRIPTION = 'Fliesen Jarek ist Ihr Fliesenleger in Cuxhaven für Badsanierung, Fliesenverlegung, Naturstein, Abdichtung und Reparaturen. Persönliche Beratung und saubere Ausführung.';
const DEFAULT_IMAGE = '/images/projekte/neuneuneu/WhatsApp Image 2025-06-29 at 10.50.35 (4).jpeg';

const absoluteUrl = (value) => {
  if (!value) return SITE_URL;
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

const Seo = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  type = 'website',
  canonicalPath,
  noindex = false,
  schema,
  imageAlt
}) => {
  const { pathname } = useLocation();
  const normalizedPath = canonicalPath || pathname || '/';
  const canonicalUrl = absoluteUrl(normalizedPath === '/' ? '/' : normalizedPath.replace(/\/$/, ''));
  const pageTitle = title
    ? (title.toLowerCase().includes(SITE_NAME.toLowerCase()) ? title : `${title} | ${SITE_NAME}`)
    : DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const socialImage = encodeURI(absoluteUrl(image));

  return (
    <Helmet htmlAttributes={{ lang: 'de' }}>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="de-DE" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content={imageAlt || pageTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={socialImage} />
      <meta name="twitter:image:alt" content={imageAlt || pageTitle} />

      <meta name="geo.region" content="DE-NI" />
      <meta name="geo.placename" content="Cuxhaven" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
